import Vue from 'vue'
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'

// Explicit "deep" imports to improve bundle size.
// https://fontawesome.com/how-to-use/with-the-api/other/tree-shaking
import {
  faMicrosoft,
  faGoogle,
} from '@fortawesome/free-brands-svg-icons'

import {
  faSpinner,
  faSortUp,
  faSortDown,
  faKey,
  faChevronRight,
  faChevronLeft,
  faSearch,
  faShoePrints,
  faBars,
  faBell,
  faTimesCircle,
  faQuestionCircle,
  faExclamationCircle,
  faWindowClose,
  faCompress,
  faExpandArrowsAlt,
  faUser,
  faUsers,
  faDownload,
  faFileInvoice,
  faImage,
  faPlus,
  faVideo,
  faLink,
  faEdit,
  faPen,
  faPlay,
  faForward,
  faBackward,
  faPause,
  faWindowMaximize,
  faUserSlash,
  faDna,
  faPodcast,
  faArchive,
  faLock,
  faLockOpen,
  faTags,
  faEnvelope,
  faCopy,
  faPaste,
  faClone,
  faTrash,
  faArrowRight,
  faFilter,
  // Previously from pro-light, now using solid free equivalents
  faCircle,
  faExclamationTriangle,
  faIdBadge,
  faTv,
  faFileAlt,
  faAddressBook,
  faClipboard,
  faAngleDoubleDown,
  faAngleDoubleUp,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faSpinner,
  faSortDown,
  faSortUp,
  faMicrosoft,
  faGoogle,
  faKey,
  faChevronRight,
  faChevronLeft,
  faSearch,
  faShoePrints,
  faBars,
  faTimesCircle,
  faVideo,
  faExclamationTriangle,
  faWindowClose,
  faCompress,
  faExpandArrowsAlt,
  faUser,
  faUsers,
  faDownload,
  faFileInvoice,
  faImage,
  faPlus,
  faCircle,
  faBell,
  faIdBadge,
  faTv,
  faFileAlt,
  faAddressBook,
  faQuestionCircle,
  faEdit,
  faPen,
  faPlay,
  faBackward,
  faForward,
  faPause,
  faWindowMaximize,
  faExclamationCircle,
  faUserSlash,
  faDna,
  faPodcast,
  faArchive,
  faLock,
  faLockOpen,
  faTags,
  faEnvelope,
  faClipboard,
  faLink,
  faCopy,
  faPaste,
  faClone,
  faTrash,
  faArrowRight,
  faAngleDoubleDown,
  faAngleDoubleUp,
  faFilter,
)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
